export enum HistoryColor {
  SUCCESS = 'green',
  WARNING = 'orange',
  DANGER = 'red',
}
